import { defineMessages } from 'react-intl';

export const messages: {
	chatMessageInputLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sendMessageLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	chatMessageInputLabel: {
		id: 'dtac.graphExplorer.cyphieChat.chatInput.chatMessageInputLabel.non-final',
		defaultMessage: 'Chat message input',
		description: 'Accessible label for the chat message input field',
	},
	sendMessageLabel: {
		id: 'dtac.graphExplorer.cyphieChat.chatInput.sendMessageLabel.non-final',
		defaultMessage: 'Send message',
		description: 'Accessible label for the send message button and icon',
	},
});
